<template>
    <div id="lostPassword" class="lost__password_modal" data-uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
            <button class="uk-modal-close" type="button"><img src="/images/x.png" alt=""></button>
            <div class="lost__password_wrapper">
                <div class="lost__password_header">
                    ЗАБЫЛИ ПАРОЛЬ?
                </div>
                <div class="lost__password_title">
                    Если Вы забыли пароль, введите email и на него будет выслана временная ссылка для изменения пароля
                </div>
                <form action="" novalidate v-on:submit.prevent="submit">
                    <div class="email__wrapper">
                        <label>E-mail:</label>
                        <input type="email" name="email" v-model.trim="email" @input="show_error=false"
                               :class="{invalid: ($v.email.$dirty && !$v.email.required) || ($v.email.$dirty && !$v.email.email)}">
                        <span class="valid_error"
                              v-if="($v.email.$dirty && !$v.email.required)">Обязательное поле</span>
                        <span class="valid_error"
                              v-else-if="($v.email.$dirty && !$v.email.email)">Пожалуйста, введите корректный адрес электронной почты.</span>
                        <span class="valid_error"
                              v-if="show_error">Указаный Email не существует</span>
                    </div>
                    <button type="submit">ОТПРАВИТЬ</button>
                </form>
                <LostPasswordSended :email="email"/>
            </div>
        </div>
    </div>
</template>
<script>
import {email, required} from "vuelidate/lib/validators";
import UIkit from 'uikit'
import axios from "axios";

export default {
    name: "lost-password-modal",
    components:{LostPasswordSended: ()=> import('./lost-password-sended'),},
    data: () => ({
        email: "",
        show_error: false
    })
    ,
    validations: {
        email: {required, email},

    },
    methods: {
        submit() {
            if (this.$v.$invalid) {
                this.$v.$touch();
            } else {

                axios.post('/password/email', this.$data).then((response) => {
                    if (response.data.res == 'success') {
                        UIkit.modal(document.getElementById('lostPasswordSended')).show();
                        this.show_error = false;
                    }

                }).catch((err) => {
                    this.show_error = true;

                });

            }


        },

    }
};
</script>
<style lang="scss" scoped>
.lost__password_wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .lost__password_header {
        color: #090909;
        font-weight: 600;
        text-align: center;
        font-size: 17px;
        margin-bottom: 10px;
        text-transform: uppercase;
    }

    .lost__password_title {
        float: right;
        font-style: normal;
        font-weight: normal;
        font: 14px/17px 'Roboto Regular', sans-serif;
        color: #090909;
    }

    form {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .email__wrapper {
            position: relative;
            margin-bottom: 10px;
            width: 100%;

            input {
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                width: 100%;
                padding: 8px 10px;
                border: 0;
                background: #F3F4F5;
                border-radius: 2.64604px;
                border: none;
                padding: 0 8px;
                box-sizing: border-box;
                height: 32px;
            }

            label {
                font-family: Noto Sans SC;
                font-style: normal;
                font-weight: normal;
                font-size: 16px;
                line-height: 32px;
                color: #090909;
                margin-bottom: 3px;
            }

            .valid_error {
                color: red;
                font-family: "RobotoLight", sans-serif;
            }

        }

        button {
            border: 0;
            cursor: pointer;
            padding: 10px 20px;
            width: 220px;
            background: linear-gradient(to bottom, rgba(253, 94, 110, 1) 0, rgba(247, 82, 103, 1) 18%, rgba(219, 22, 68, 1) 73%, rgba(209, 1, 56, 1) 100%);
            border-radius: 12px;
            text-decoration: none;
            font: 14px/16px 'RobotoRegular', sans-serif;
            color: #fff;

            &:hover {
                background: linear-gradient(to bottom, rgba(203, 17, 66, 1) 0, rgba(209, 2, 57, 1) 2%, rgba(215, 14, 64, 1) 18%, rgba(243, 74, 99, 1) 73%, rgba(253, 93, 110, 1) 98%, rgba(237, 104, 118, 1) 100%);
            }
        }

    }
}
</style>
